import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource/nunito-sans/400.css'
import '@fontsource/nunito-sans/500.css'
import '@fontsource/nunito-sans/600.css'
import '@fontsource/nunito-sans/700.css'
import './index.css'
import { App } from './App'
import { AuthProvider } from './auth/AuthProvider'
import { QueryProvider } from './providers/QueryProvider'
import { ErrorBoundary } from './components/ErrorBoundary'
import { I18nProvider } from './i18n'
import { PwaInstallProvider } from './hooks/PwaInstallProvider'

// AuthProvider sits above I18nProvider/PwaInstallProvider so App can read auth
// readiness (useAuth) for the splash gate, while screens still get i18n + install.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryProvider>
        <AuthProvider>
          <I18nProvider>
            <PwaInstallProvider>
              <App />
            </PwaInstallProvider>
          </I18nProvider>
        </AuthProvider>
      </QueryProvider>
    </ErrorBoundary>
  </StrictMode>,
)
